import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { ConfirmModalComponent } from "./confirm-modal/confirm-modal.component";
import { LoginModalComponent } from "./login-modal/login-modal.component";
import { ActionModalComponent } from "./action-modal/action-modal.component";
import { ErrorModalComponent } from "./error-modal/error-modal.component";
import { ProceedConfirmModalComponent } from "./proceed-confirm-modal/proceed-confirm-modal.component";
import { SharedModule } from "@shared/shared.module";
import { NamelessActivationModalComponent } from './nameless-activation-modal/nameless-activation-modal.component';
import { PrShare } from "./pr/prshare-modal/pr-share-modal";
import { PrConfirm } from "./pr/prconfirm-modal/pr-confirm-modal";
import { PrSuccess } from "./pr/prsucces-modal/pr-sucess.component";
import { MultiDateCalendarComponentComponent } from './multi-date-calendar-component/multi-date-calendar-component.component';
import { ComissioniModalComponent } from './comissioni-modal/comissioni-modal.component';




@NgModule({
    imports: [
        SharedModule,
        ConfirmModalComponent,
        LoginModalComponent,
        // ActionModalComponent,
        ErrorModalComponent,
        ProceedConfirmModalComponent,
        NamelessActivationModalComponent,
        PrShare,
        PrConfirm,
        PrSuccess,
        MultiDateCalendarComponentComponent,
        ComissioniModalComponent
    ],
    exports: [
        ConfirmModalComponent,
        LoginModalComponent,
        // ActionModalComponent,
        ErrorModalComponent,
        ProceedConfirmModalComponent,
        NamelessActivationModalComponent,
        PrShare,
        PrConfirm,
        PrSuccess
    ]
})
export class ModalsModule {}
